import React, { Suspense, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MotifLoader } from '@ey-xd/motif-react';
import Routes from '../app_config/routeConfig';
import envConfig from '../app_config/envConfig';
import CartAndComparePopup from '../components/cartAndComparePopup/CartAndComparePopup';
import Footer from '../components/footer/Footer';
import PrivateRoute from '../components/privateRoute/PrivateRoute';
import initConfigurationData from '../store/actions/configurationAction';
import AppConfig from '../app_config/appConfig';
import { history } from '../store/store';
import Gnav from '../components/gnav/Gnav';


function App() {
  const dispatch = useDispatch();
  const authStore = useSelector(state => state.authenticationData);
  const currentUser = authStore && authStore.userDetails && authStore.userDetails.email && authStore.userDetails.email.toLowerCase();
  const isLoading = useSelector(state => state.generalData.isLoading);
  const showLazyLoader = true;

  const checkRedirect = () => {
    let redirectRoute = "";
    if (window.sessionStorage.getItem("redirectRoute") && window.sessionStorage.getItem("redirectRoute").length > 0) {
      redirectRoute = window.sessionStorage.getItem("redirectRoute").replace && window.sessionStorage.getItem("redirectRoute").replace("#/","/");
      window.sessionStorage.removeItem("redirectRoute");
    }
    else if (window.location.hash.indexOf('login') >= 0 || !window.location.hash.split("#/")[1]) {
      redirectRoute = AppConfig.routePaths.home;
    }
    if (redirectRoute){
      if(Array.isArray(Object.keys(AppConfig.routePaths))){
        const matchRoute = Object.keys(AppConfig.routePaths).find(routeKey=>
          AppConfig.routePaths[routeKey].includes(redirectRoute.split("?")[0])
        )
        redirectRoute = matchRoute? redirectRoute: AppConfig.routePaths.home;
      }
      history.replace(redirectRoute);
    }
  };

  // initialize adobe analytics script
  const injectAdobeScript = () => {
    const env = process.env.REACT_APP_ENVIRONMENT_NAME;
      const adobeScript = document.createElement("script");
      adobeScript.innerHTML = `InitializeAdobe();function InitializeAdobe() {adobeAnalytics.environment = "${env}";adobeAnalytics.email = "${currentUser}";adobeAnalytics.hashedUserId = sha256(adobeAnalytics.email);adobeAnalytics.injectAdobePageParametersScript();adobeAnalytics.injectAdobeLaunchScriptreferenceOnPageLoad("${envConfig.adobeSource}");adobeAnalytics.injectFooterCode();}`;
      adobeScript.async = false;
      adobeScript.nonce = '2726c7f26c';
      document.body.appendChild(adobeScript);
  };

  useEffect(() => {
    if (authStore.isAuthenticated) {
      checkRedirect();
      dispatch(initConfigurationData());
      injectAdobeScript();
      window.sessionStorage.setItem('refsrc', window.location.href.toLowerCase());
    }
  }, [authStore.isAuthenticated]);


  return (
    <div className="App">
   
   <Gnav />
      <Suspense fallback={<MotifLoader show={showLazyLoader} fullscreen={showLazyLoader} />}>
        <MotifLoader show={isLoading} fullscreen={isLoading} />
        { (authStore && authStore.isAuthenticated)?
          (<CartAndComparePopup />):null}
       
        <Switch>
          {Routes.map(route => {
            if (route.private) {
              return (
                <PrivateRoute
                  path={route.path}
                  exact={route.exact}
                  key={route.path}
                  component={route.component}
                />
              );
            }
            return (
              <Route
                path={route.path}
                exact={route.exact}
                key={route.path}                      
                component={route.component}                                
              />
            );
          })}
        </Switch>
      </Suspense>
      <Footer />
    </div>
  );
}

export default App;
